/** Pestañas del Panel General — máximo ~4 visibles según rol y modo. */

export const PANEL_GENERAL_TABS = {
  MODULOS: "modulos",
  DATOS_MAESTROS: "datos-maestros",
  EQUIPO: "equipo",
  COMUNICACION: "comunicacion",
  /** @deprecated alias — use HERRAMIENTAS */
  MANTENIMIENTO: "mantenimiento",
  HERRAMIENTAS: "herramientas",
};

/** Deep links a pestañas del Panel General. */
export const PANEL_GENERAL_EQUIPO_TAB = "/?panel=equipo";
export const PANEL_GENERAL_COMUNICACION_TAB = "/?panel=comunicacion";

/**
 * URL al Panel General con pestaña activa y returnTo opcional.
 * @param {string} tabId — id de PANEL_GENERAL_TABS (omitir o modulos → sin query panel)
 * @param {string} [returnTo]
 */
export function buildPanelGeneralTabPath(tabId, returnTo) {
  const params = new URLSearchParams();
  const panel = String(tabId || "").trim();
  if (panel && panel !== PANEL_GENERAL_TABS.MODULOS) {
    params.set("panel", panel);
  }
  const back = String(returnTo || "").trim().split("?")[0];
  if (back && back !== "/") {
    params.set("returnTo", back);
  }
  const qs = params.toString();
  return qs ? `/?${qs}` : "/";
}

/**
 * @param {object} ctx
 * @param {string} [ctx.mode]
 * @param {boolean} [ctx.showEquipo]
 * @param {boolean} [ctx.showHerramientas]
 * @param {boolean} [ctx.showMantenimiento] — alias de showHerramientas
 * @returns {Array<{ id: string, label: string, testId: string }>}
 */
export function getPanelGeneralTabs({
  mode = "despacho",
  showEquipo = false,
  showHerramientas = false,
  showMantenimiento = false,
} = {}) {
  const showTools = showHerramientas || showMantenimiento;
  const tabs = [
    {
      id: PANEL_GENERAL_TABS.MODULOS,
      label: "Módulos",
      testId: "panel-tab-modulos",
    },
  ];

  if (mode !== "distribuidor") {
    tabs.push({
      id: PANEL_GENERAL_TABS.DATOS_MAESTROS,
      label: "Datos Maestros",
      testId: "panel-tab-datos-maestros",
    });
  }

  if (showEquipo && mode !== "distribuidor") {
    tabs.push({
      id: PANEL_GENERAL_TABS.EQUIPO,
      label: "Actividades de Equipo",
      testId: "panel-tab-equipo",
    });
    tabs.push({
      id: PANEL_GENERAL_TABS.COMUNICACION,
      label: "BNT Asistente",
      testId: "panel-tab-comunicacion",
    });
  }

  if (showTools && mode !== "distribuidor") {
    tabs.push({
      id: PANEL_GENERAL_TABS.HERRAMIENTAS,
      label: "Herramientas",
      testId: "panel-tab-herramientas",
    });
  }

  return tabs;
}

/** Normaliza query ?panel= o valor inválido al primer tab disponible. */
export function resolvePanelGeneralTab(requested, availableTabs) {
  const ids = (availableTabs || []).map((t) => t.id);
  if (!ids.length) return PANEL_GENERAL_TABS.MODULOS;
  const normalized =
    requested === PANEL_GENERAL_TABS.MANTENIMIENTO ? PANEL_GENERAL_TABS.HERRAMIENTAS : requested;
  if (normalized && ids.includes(normalized)) return normalized;
  return ids[0];
}
